export default __webpack_public_path__ + "static/media/Yellowwood Bark.2c3112ad.PNG";